import { Tokenisation } from "../../../../src/posts/2023-01-30-full-text-search/Tokenisation";
import { CleanSearchText } from "../../../../src/posts/2023-01-30-full-text-search/CleanSearchText";
import * as React from 'react';
export default {
  Tokenisation,
  CleanSearchText,
  React
};